/**
 * Модал юнинотисов.
 */
export const noticePath = '/uni-notice'
export const uniNoticeFullPath = '/uni-notice/:noticeId'
